import { Pressable, StyleSheet, Text, View } from 'react-native'
import { toFriendlyError } from '../lib/error-message'
import { colors, fontFamily, fontSize, radius, space } from '../tokens'

type Props = {
  // Accepts the raw tRPC/query error; friendly copy is derived here so every
  // call site renders errors identically. Pass onRetry for transient failures
  // (5xx / network / rate-limit) to surface a "Try again" affordance.
  error: unknown
  onRetry?: () => void
}

export const ErrorNotice = ({ error, onRetry }: Props) => {
  if (!error) return null
  const { message, transient } = toFriendlyError(error)
  return (
    <View accessibilityRole="alert" style={styles.box}>
      <Text style={styles.text}>{message}</Text>
      {transient && onRetry ? (
        <Pressable accessibilityRole="button" onPress={onRetry} style={styles.retry}>
          <Text style={styles.retryText}>Try again</Text>
        </Pressable>
      ) : null}
    </View>
  )
}

const styles = StyleSheet.create({
  box: {
    marginTop: space[16],
    padding: space[16],
    borderRadius: radius.sm,
    backgroundColor: colors.error[100],
    borderLeftWidth: 4,
    borderLeftColor: colors.error[700],
    gap: space[8],
  },
  text: {
    color: colors.error[900],
    fontSize: fontSize.small,
    lineHeight: 20,
    fontFamily: fontFamily.body,
  },
  retry: { alignSelf: 'flex-start' },
  retryText: {
    color: colors.error[900],
    fontSize: fontSize.small,
    fontWeight: '700',
    textDecorationLine: 'underline',
    fontFamily: fontFamily.body,
  },
})
